import request from './services/axios.js'

export default {
  //获取刊物列表接口
  GetMobileBookDetails: (params) => {
    return request({
      params,
      url: '/ebook/mobile/getOne',
      method: 'get'
    })
  },
  //获取刊物列表接口
  GetPaperDetails: (params) => {
    return request({
      params,
      url: '/ebook/epaper/getOneEpaper',
      method: 'get'
    })
  },
  // 获取电子书列表分页时调用的接口
  GetEbookByPage: (params) => {
    return request({
      params,
      url: '/ebook/getEbookByPage',
      method: 'get'
    })
  },
  // 获取数字报列表分页时调用的接口
  getEPaperByPage: (params) => {
    return request({
      params,
      url: '/ebook/epaper/getEpaperByPage',
      method: 'get'
    })
  },
  getBooksParsingStatus: () => {
    return request({
      url: '/ebook/hasParsingEbook',
      method: 'get'
    })
  },
  getPapersParsingStatus: () => {
    return request({
      url: '/ebook/epaper/hasParsingEpaper',
      method: 'get'
    })
  },
  // 获取电子书列表分页时调用的接口
  delBook: (params) => {
    return request({
      params,
      url: '/ebook/delBook',
      method: 'get'
    })
  },
  // 删除数字报
  delPaper: (params) => {
    return request({
      params,
      url: '/ebook/epaper/delEpaper',
      method: 'get'
    })
  },
  //获取上传使用空间
  getSpace: (params) => {
    return request({
      params,
      url: '/ebook/getTotalSpace',
      method: 'get'
    })
  },
  //获取微信配置
  getWXConfig: (params) => {
    return request({
      params,
      url: '/ebook/wxShareParams',
      method: 'get'
    })
  },
  getPaperWXConfig: (params) => {
    return request({
      params,
      url: '/ebook/epaper/wxShareParams',
      method: 'get'
    })
  },
  //获取专辑微信分享
  getAlbumWXConfig: (params) => {
    return request({
      params,
      url: '/ebook/albumWxShareParams',
      method: 'get'
    })
  },
  // 统计浏览量
  sendPageView: (params) => {
    return request({
      data: params,
      url: '/ebook/addPv',
      method: 'post'
    })
  },
  // 统计数字报浏览量
  sendPaperPageView: (params) => {
    return request({
      data: params,
      url: '/ebook/epaper/addPv',
      method: 'post'
    })
  },
  // 内容检索
  searchInPdfBook: (params) => {
    return request({
      params,
      url: '/ebook/searchInPdfBook',
      method: 'post'
    })
  },
  // 免登录内容检索
  searchInPdfBookMobile: (params) => {
    return request({
      params,
      url: '/ebook/mobile/searchInPdfBook',
      method: 'post'
    })
  },
  // 关键字
  textSearchInPdf: (params) => {
    return request({
      params,
      url: '/ebook/mobile/textSearchInPdf',
      method: 'post'
    })
  },
  epaperTextSearchInPdf: (params) => {
    return request({
      params,
      url: '/ebook/epaper/mobile/textSearchInPdf',
      method: 'post'
    })
  },
  epaperTextSearchInArticle: (params) => {
    return request({
      params,
      url: '/ebook/epaperXY/textSearchInArticle',
      method: 'get'
    })
  },
  // 关键字坐标
  getKeyPos: (params) => {
    return request({
      params,
      url: '/ebook/mobile/getKeyPos',
      method: 'post'
    })
  },
  // 关键字坐标
  getEpaperKeyPos: (params) => {
    return request({
      params,
      url: '/ebook/epaper/mobile/getKeyPos',
      method: 'post'
    })
  },
  uploadPosterPic: (params) => {
    return request({
      data: params,
      url: '/ebook/setPosterPic',
      method: 'post'
    })
  },
  // 一键生成目录
  generationCatalog: (params) => {
    return request({
      params,
      url: '/ebook/useBookSelfCatalog',
      method: 'get'
    })
  },
  // 一键生成目录(数字报PDF)
  useEpaperSelfCatalog: (params) => {
    return request({
      params,
      url: '/ebook/epaper/useEpaperSelfCatalog',
      method: 'get'
    })
  },
  // 撤销恢复目录
  repealCatalog: (params) => {
    return request({
      params,
      url: '/ebook/withdrawCatalog',
      method: 'get'
    })
  },
  // 是否显示撤销按钮
  repealBtn: (params) => {
    return request({
      params,
      url: '/ebook/canWithdrawCatalog',
      method: 'get'
    })
  },
  // 撤销恢复目录（PDF数字报）
  epaperRepealCatalog: (params) => {
    return request({
      params,
      url: '/ebook/epaper/withdrawEpaperCatalog',
      method: 'get'
    })
  },
  // 是否显示撤销按钮（PDF数字报）
  epaperRepealBtn: (params) => {
    return request({
      params,
      url: '/ebook/epaper/canWithdrawCatalog',
      method: 'get'
    })
  },
  // 编辑书签
  setBookMark: (params) => {
    return request({
      data: params,
      url: '/ebook/setBookMark',
      method: 'post'
    })
  },
  // 获取书签列表
  findBookMarkList: (id) => {
    return request({
      url: '/ebook/findBookMarkList?ebookId=' + id,
      method: 'get'
    })
  },
  // 删除书签
  delBookMarkById: (id) => {
    return request({
      url: '/ebook/delBookMarkById?id=' + id,
      method: 'get'
    })
  },
  // 删除全部书签
  delBookMarkByEbookId: (id) => {
    return request({
      url: '/ebook/delBookMarkByEbookId?id=' + id,
      method: 'get'
    })
  },
  // 获取期刊/报纸类专辑所含期刊列表
  getAllBooks: (params) => {
    return request({
      params,
      url: '/ebook/getMagazinesByPublishDate'
    })
  },
  getUserSpace: (params) => {
    return request({
      params,
      url: '/ebook/getMemberSpace',
      method: 'get'
    })
  },
  //子账号获取空间
  getChildUserSpace: (params) => {
    return request({
      params,
      url: '/ebook/childAccount/getChildSpaceSum',
      method: 'get'
    })
  },
  //子账号获取书刊专辑数量
  getProductsCount: (params) => {
    return request({
      params,
      url: '/ebook/childAccount/getSum',
      method: 'get'
    })
  },
  // 电子书是否可以修改读物类型
  canEditCategory: (params) => {
    return request({
      params,
      url: '/ebook/canEditCategory',
      method: 'get'
    })
  },
  // 数字报详情 - 小样详情
  getXiaoYangDetail: (params) => {
    return request({
      params,
      url: '/ebook/epaperXY/getEpaperXY',
      method: 'get'
    })
  },
  // 数字报详情 - 小样列表
  getXiaoYangList: (params) => {
    return request({
      params,
      url: '/ebook/epaperXY/getEpaperXYList',
      method: 'get'
    })
  },
  // 报纸管理 - 分页列表
  getBaoZhiByPage: (params) => {
    return request({
      params,
      url: '/ebook/baozhi/getBaoZhiByPage',
      method: 'get'
    })
  },
  // 查询富媒体列表接口
  getHotspotList: (params) => {
    return request({
      params,
      url: '/ebook/hotspot/getHotspotList',
      method: 'get'
    })
  },
  // 数字报详情 - 大样列表
  getDaYangByEpaperId: (params) => {
    return request({
      params,
      url: '/ebook/epaper/getDaYangByEpaperId',
      method: 'get'
    })
  },
  // 获取科大讯飞的密钥
  getTTSParam: () => {
    return request({
      url: '/ebook/epaper/getTTSParam',
      method: 'get'
    })
  },
  // 获取往期数字报
  getEpapersByBaoZhiId: (params) => {
    return request({
      params,
      url: '/ebook/baozhi/getEpapersByBaoZhiId',
      method: 'get'
    })
  },

  // 获取富媒体按钮图标列表
  getFileAttachListByClassify: (params) => {
    return request({
      params,
      url: '/ebook/fileAttach/getFileAttachListByClassify',
      method: 'get'
    })
  },

  modifyBaoZhiStyle: (params) => {
    return request({
      params,
      url: '/ebook//baozhi/modifyBaoZhiStyle',
      method: 'get'
    })
  },
  getBaoZhiByld: (params) => {
    return request({
      params,
      url: '/ebook/baozhi/getBaoZhiByld',
      method: 'get'
    })
  },
  getRecentEpaper: (params) => {
    return request({
      params,
      url: '/ebook//epaper/getRecentEpaper',
      method: 'get'
    })
  },
  generateDownLink: (params) => {
    return request({
      params,
      url: '/ebook/epaper/generateDownLink',
      method: 'get'
    })
  },
  //获取带音频html包下载链接
  generateHtmlDownLink: (params) => {
    return request({
      params,
      url: '/cloudR/download/generateLink',
      method: 'get'
    })
  },
  // 数字报详情 - 大样详情
  findDaYangByXYId: (params) => {
    return request({
      params,
      url: '/ebook/epaperDY/findDaYangByXYId',
      method: 'get'
    })
  },
  // 获取文章列表
  getArticleListByEpaperId: (params) => {
    return request({
      params,
      url: '/ebook/epaperXY/getArticleListByEpaperId',
      method: 'get'
    })
  },
  //报纸管理 - 详情
  getBaoZhiById: (params) => {
    return request({
      params,
      url: '/ebook/baozhi/getBaoZhiById',
      method: 'get'
    })
  },
  //报纸管理 - 报纸设置
  editBaoZhiSetting: (params) => {
    return request({
      data: params,
      url: '/ebook/baozhi/editBaoZhi',
      method: 'post'
    })
  },
  //报纸管理 - 数字报发布
  publishEpaper: (params) => {
    return request({
      params,
      url: '/ebook/epaper/publishEpaper',
      method: 'get'
    })
  },
  //报纸管理 - 数字报更新状态

  /* 参数	是否必须	说明
		id	是	数字报标识id
		status	是	数字报状态。0-待发布，1-已发布，2-未审核，3-待审核，4-未通过。 
		提交审核 status=3
		审核通过 status=0
		审核未通过 status=4
		下线 status=0
	*/
  modifyEpaperStatus: (params) => {
    return request({
      params,
      url: '/ebook/epaper/modifyEpaperStatus',
      method: 'get'
    })
  }
}

// 获取空间
export const getUserSpace = (params) => {
  return request({
    params,
    url: '/ebook/getMemberSpace',
    method: 'get'
  })
}

//子账号获取书刊专辑数量
export const getProductsCount = (params) => {
  return request({
    params,
    url: '/ebook/childAccount/getSum',
    method: 'get'
  })
}

export const getAddress = () => {
  return request({
    url: 'http://pv.sohu.com/cityjson?ie=utf-8',
    method: 'get'
  })
}

export const getHttpsAddress = () => {
  return request({
    url: 'https://pv.sohu.com/cityjson?ie=utf-8',
    method: 'get'
  })
}
